import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import EmisionBoletaSeccionModal from '../EmisionBoletaSeccionModal';
import { isNull } from '../../../utils/validator';
import { useEntidad } from '../../hooks';


const EmisionBoletaSeccionesGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idEmisionDefinicion: 0,
      idBoletaDefinicion: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      listBoletaSecciones: [],
      listCalculos: [],
      listVariables: [],
      listFunciones: [],
      listParametros: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const listBoletaSecciones = props.data.listBoletaSecciones.filter(x => x.state !== 'r').sort((a, b) => a.orden - b.orden);
      return {...prevState,
        idEmisionDefinicion: props.data.idEmisionDefinicion,
        idBoletaDefinicion: props.data.idBoletaDefinicion,
        listBoletaSecciones: listBoletaSecciones,
        listCalculos: props.data.listCalculos,
        listVariables: props.data.listVariables,
        listFunciones: props.data.listFunciones,
        listParametros: props.data.listParametros
      };
    });
  }
  useEffect(mount, [props.data]);

  const [getListEntidad, getRowEntidad] = useEntidad({
    entidades: ['BoletaDefinicionSeccion'],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'BoletaDefinicionSeccion',
      timeout: 0
    }
  });

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickEmisionBoletaSeccionAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickEmisionBoletaSeccionView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && !data.row.original.soloLectura && (
                                  <div onClick={ (event) => handleClickEmisionBoletaSeccionModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && !data.row.original.soloLectura && (
                                  <div onClick={ (event) => handleClickEmisionBoletaSeccionRemove(data.value) } className="link">
                                     <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}                                 
                              </div>

  const getCodigoEmisionBoletaSeccion = (idBoletaDefinicionSeccion) => {
    const row = getRowEntidad('BoletaDefinicionSeccion', idBoletaDefinicionSeccion);
    return (row) ? row.codigo : '';
  }

  const getNombreEmisionBoletaSeccion = (idBoletaDefinicionSeccion) => {
    const row = getRowEntidad('BoletaDefinicionSeccion', idBoletaDefinicionSeccion);
    return (row) ? row.nombre : '';
  }

  const tableColumns = [
    { Header: 'Orden', accessor: 'orden', width: '5%', disableSortBy: true  },
    { Header: 'Código', Cell: (props) => getCodigoEmisionBoletaSeccion(props.value), id: 'codigoSeccion', accessor: 'idBoletaDefinicionSeccion', width: '15%', disableSortBy: true  },
    { Header: 'Sección', Cell: (props) => getNombreEmisionBoletaSeccion(props.value), id: 'nombreSeccion', accessor: 'idBoletaDefinicionSeccion', width: '25%', disableSortBy: true  },
    { Header: 'Descripción', accessor: 'descripcion', width: '45%', disableSortBy: true  },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickEmisionBoletaSeccionAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idEmisionDefinicion: state.idEmisionDefinicion,
        idBoletaDefinicionSeccion: 0,
        descripcion: "",
        formulaCondicion: "",
        formulaSeccion: "",
        orden: 0,
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickEmisionBoletaSeccionView = (id) => {
    setState(prevState => {
      const rowForm = state.listBoletaSecciones.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickEmisionBoletaSeccionModify = (id) => {
    setState(prevState => {
      const rowForm = state.listBoletaSecciones.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickEmisionBoletaSeccionRemove = (id) => {
    setState(prevState => {
      const rowForm = state.listBoletaSecciones.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  } 

  //funciones
  function RemoveEmisionBoletaSeccion(row) {
    row.state = 'r';
    props.onChange('EmisionBoletaSeccion', row);
  }

  function UpdateEmisionBoletaSeccion(row) {
    row.state = isNull(state.listBoletaSecciones.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('EmisionBoletaSeccion', row);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveEmisionBoletaSeccion(row);
            }}
        />
    }

    {state.showForm && 
        <EmisionBoletaSeccionModal
            disabled={!state.modeFormEdit}
            procesaElementos={props.procesaElementos}
            procesaRubros={props.procesaRubros}
            procesaCarteles={props.procesaCarteles}
            data={{
              entity: state.rowForm,
              idBoletaDefinicion: state.idBoletaDefinicion,
              listBoletaDefinicionSeccion: getListEntidad('BoletaDefinicionSeccion'),
              listCalculos: state.listCalculos,
              listVariables: state.listVariables,
              listFunciones: state.listFunciones,
              listParametros: state.listParametros
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateEmisionBoletaSeccion(row);
            }}
            onMovePrevious={(state.rowForm && state.listBoletaSecciones.some(f => f.orden < state.rowForm.orden)) ? () => {
              //tomo el primero de los menores ordenados de mayor a menor
              const idRowPrevious= state.listBoletaSecciones.filter(f => f.orden < state.rowForm.orden).sort((a, b) => b.orden - a.orden)[0].id;
              if (state.modeFormEdit)
                handleClickEmisionBoletaSeccionModify(idRowPrevious);
              else
                handleClickEmisionBoletaSeccionView(idRowPrevious);
            } : null}
            onMoveNext={(state.rowForm && state.listBoletaSecciones.some(f => f.orden > state.rowForm.orden)) ? () => {
              //tomo el primero de los mayores ordenados de menor a mayor
              const idRowNext = state.listBoletaSecciones.filter(f => f.orden > state.rowForm.orden).sort((a, b) => a.orden - b.orden)[0].id;
              if (state.modeFormEdit)
                handleClickEmisionBoletaSeccionModify(idRowNext);
              else
                handleClickEmisionBoletaSeccionView(idRowNext);
            } : null}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.listBoletaSecciones}
    />

  </>
  );
}

EmisionBoletaSeccionesGrid.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

EmisionBoletaSeccionesGrid.defaultProps = {
  disabled: false
};

export default EmisionBoletaSeccionesGrid;